import {ChangeDetectorRef, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SupportApiService} from '../../services/support-api.service';
import {BehaviorSubject, finalize, map, Observable, of, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {MatBadge} from '@angular/material/badge';
import {MatIcon} from '@angular/material/icon';
import {AsyncPipe, DatePipe} from '@angular/common';
import {NgArrayPipesModule} from 'ngx-pipes';
import {TicketInterface} from '../../interfaces/http.interface';
import {ProgressSpinnerComponent} from '../progress-spinner/progress-spinner.component';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-chat-list',
  imports: [
    TopBarComponent,
    MatBadge,
    MatIcon,
    AsyncPipe,
    NgArrayPipesModule,
    DatePipe,
    ProgressSpinnerComponent,
    MatProgressSpinner
  ],
  templateUrl: './chat-list.component.html',
  styleUrl: './chat-list.component.scss'
})
export class ChatListComponent implements OnInit{
  private router: Router = inject(Router);
  private supportApiService: SupportApiService = inject(SupportApiService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  public loading = true;
  public chats$: BehaviorSubject<TicketInterface[]> = new BehaviorSubject<TicketInterface[]>([]);
  private destroyRef: DestroyRef= inject(DestroyRef);



  ngOnInit(): void {
    this.loading = true;
    this.cdr.detectChanges();
    this.supportApiService.getTickets().pipe(
      map(data => data?.data),
      tap(chats => {
        this.chats$.next(chats);
        this.cdr.detectChanges();
      }),
      takeUntilDestroyed(this.destroyRef),
      finalize(() => {
        this.loading = false
      })
    ).subscribe();
  }

public navigateToChat(chat: TicketInterface) {
  this.router.navigate([`/chat`], {queryParams: {ticket_uuid: chat.id, status: chat.status}});
}


}
